"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertPreferenceFactory = void 0;
const Factory = require("factory.ts");
exports.alertPreferenceFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    contact_type: 'PersonaEmailAddress',
    contact_value: 'alert@preference.com',
    context_id: 1234,
    context_type: 'Organization',
    enabled: false,
});
